import { render } from "./GirlPostListItem.vue?vue&type=template&id=1afc06ad&scoped=true"
import script from "./GirlPostListItem.vue?vue&type=script&lang=js"
export * from "./GirlPostListItem.vue?vue&type=script&lang=js"

import "./GirlPostListItem.vue?vue&type=style&index=0&id=1afc06ad&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1afc06ad"]])

export default __exports__